import React from "react";
import contextProvider from "../../../contextProvider";
import { Row, Col, ListGroup, ListGroupItem } from "reactstrap";
import classnames from "classnames";

import _ReactOBaseComponent, {
  withDefinedContext,
} from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";

import ReactOTable from "../../../_L1_components/Elements/ReactOTable";
import ReactOTooltip from "../../../_L1_components/Elements/ReactOTooltip";
import ReactOCollapse from "../../../_L1_components/Elements/ReactOCollapse";
import Section from "../../../_L1_components/Layout/Section";
import Panel from "../../../_L1_components/Layout/Panel";

const context_exposed_methods = [];

class Dashboard extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      data: null,
    };
    super(props, initState);

    this.apiStore = null;
    this.actionsShelf = null;
    this._essid_sorting = "asc";
  }

  /////////////////////////
  //	Lifecycle methods

  onComponentDidMount() {
    this.getAppContext().getLocalStorageService().remove("measure_graph_view");
    this.getAppContext().getLocalStorageService().remove("measure_graph_view");
    this.apiStore = this.getAppContext().getApiStoreService();
    this.actionsShelf = this.getAppContext().getActionsShelfService();
    this.loadEssids();
  }

  loadEssids(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("dashboard_essids_view", {
          ___onSuccess: (status, data) => {
            data.essidList = Object.keys(data).sort();
            this._selectedEssid = data.essidList[0];
            this._selectedTest = data[this._selectedEssid].tests[0].test;
            this.setState({
              data: data,
              loading: false,
            });
          },
        });
      },
    );
  }

  onComponentWillUnmount() {}

  onRender() {
    return (
      <Section designType="narrow">
        <_LoadingWrapper
          loadingPlug={this.state.loading}
          hideOnLoading={true}
          minHeight
        >
          <Panel
            //	header="Network / Essid browsing"
            bodyClassName="p-0"
            rounded
          >
            {this.state.data ? (
              <Row noGutters>
                <Col xs={12} sm={3}>
                  <div
                    className={
                      "measure-result-list h-100" +
                      (!this.getAppContext().media.isMobile &&
                      !this.getAppContext().media.isTablet
                        ? " border-2 border-right border-gray300"
                        : "")
                    }
                  >
                    <div className="d-flex bg-gray150 text-muted px-3 py-2 rounded-top rounded-right-0">
                      <strong className="flex-grow-1">NETWORK LIST</strong>
                      {!this.getAppContext().media.isMobile &&
                      !this.getAppContext().media.isTablet ? (
                        <span
                          className={
                            "align-self-center" +
                            (this._essid_sorting == "asc"
                              ? " icon-sort-asc"
                              : " icon-sort-desc")
                          }
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            this._essid_sorting =
                              this._essid_sorting == "asc" ? "desc" : "asc";
                            this.forceUpdate();
                          }}
                        />
                      ) : null}
                    </div>
                    {this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet ? (
                      <div>
                        <div
                          className="bg-primary text-white p-3"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this._collapse_controller.toggle();
                          }}
                        >
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              {this._selectedEssid}
                            </div>
                            <div>
                              <span
                                style={{ fontSize: "1.5rem" }}
                                className="icon-caret-down-outline"
                              />
                            </div>
                          </div>
                        </div>
                        <ReactOCollapse
                          className=""
                          onControllerReady={(_collapse_controller) => {
                            this._collapse_controller = _collapse_controller;
                          }}
                        >
                          {this.state.data.essidList
                            .sort()
                            .map((_CURR_essid, _CURR_idx) => {
                              return (
                                <div
                                  key={_CURR_idx}
                                  style={{ cursor: "pointer" }}
                                  className={
                                    "p-3" +
                                    (this._selectedEssid == _CURR_essid
                                      ? " bg-primary text-white"
                                      : "")
                                  }
                                  onClick={() => {
                                    this._selectedEssid = _CURR_essid;
                                    this._selectedTest =
                                      this.state.data[
                                        this._selectedEssid
                                      ].tests[0].test;
                                    this.forceUpdate();
                                    this._collapse_controller.toggle();
                                  }}
                                >
                                  {_CURR_essid}
                                </div>
                              );
                            })}
                        </ReactOCollapse>
                      </div>
                    ) : (
                      <ListGroup flush>
                        {(this._essid_sorting == "asc"
                          ? this.state.data.essidList.sort()
                          : this.state.data.essidList.sort().reverse()
                        ).map((_C_essid, _C_idx) => {
                          return (
                            <ListGroupItem
                              key={_C_idx}
                              tag="a"
                              href="#"
                              action
                              className={"d-flex result-item py-3"}
                              active={this._selectedEssid == _C_essid}
                              onClick={() => {
                                this._selectedEssid = _C_essid;
                                this._selectedTest =
                                  this.state.data[
                                    this._selectedEssid
                                  ].tests[0].test;
                                this.forceUpdate();
                              }}
                            >
                              <strong className="flex-grow-1">
                                {_C_essid}
                              </strong>
                              {this._selectedEssid == _C_essid ? (
                                <span className="icon-play ml-2 align-self-center" />
                              ) : null}
                            </ListGroupItem>
                          );
                        })}
                      </ListGroup>
                    )}
                  </div>
                </Col>
                {this._selectedEssid && this.state.data[this._selectedEssid] ? (
                  <Col className="bg-light pb-3 rounded-top rounded-left-0">
                    <div className="bg-gray150 text-muted border-bottom border-gray300 px-3 py-2 rounded-top rounded-left-0">
                      <strong>TEST LIST</strong>
                    </div>
                    <Section
                      className="border-bottom border-gray300"
                      layoutManager="grid"
                      elementsPerRow={
                        this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet
                          ? 1
                          : 3
                      }
                      gridSpacing={1}
                      gridSpacingColor={this.getAppContext().colors.gray300}
                    >
                      {(() => {
                        let _isEthernet = /ethernet/i.test(this._selectedEssid);
                        return this.state.data[this._selectedEssid].tests
                          .sort()
                          .map((_C_test, _C_idx) => {
                            return (
                              <div
                                key={_C_idx}
                                className={
                                  "d-flex flex-column p-3" +
                                  (this._selectedTest == _C_test.test
                                    ? " bg-primary text-white"
                                    : "")
                                }
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  this._selectedTest = _C_test.test;
                                  this.forceUpdate();
                                }}
                              >
                                {/*<div className="sub-title mb-2"><strong>{_probesData[_C_prb_id].mac_address}</strong></div>*/}
                                <strong className="text-truncate">
                                  {_C_test.test}
                                </strong>
                                <small className="text-left d-flex align-items-center">
                                  <div className="flex-shrink-1 mr-2 pr-2">
                                    <strong
                                      className={
                                        this._selectedTest == _C_test.test
                                          ? " text-gray300"
                                          : " text-muted"
                                      }
                                    >
                                      {_isEthernet ? "" : "BSSID"} COUNT:
                                    </strong>
                                    <strong className="pl-2">
                                      <span>{_C_test.bssids_count}</span>
                                    </strong>
                                  </div>
                                </small>
                              </div>
                            );
                          });
                      })()}
                    </Section>
                    <div className="overflow-auto">
                      <ReactOTable
                        thClassName="px-3 py-1"
                        tdClassName="align-middle px-3 py-2"
                        hoverable
                        compressed={
                          this.getAppContext().media.isMobile ||
                          this.getAppContext().media.isTablet
                        }
                        compressedRowRendering={(row_items) => {
                          return (
                            <div>
                              <div className="">{row_items.name.content}</div>
                              {!/ethernet/i.test(this._selectedEssid) ? (
                                <div className="mt-2">
                                  <div className="text-muted">
                                    <small className="">
                                      <strong>{row_items.bssid.title}</strong>
                                    </small>
                                  </div>
                                  {row_items.bssid.content}
                                </div>
                              ) : null}
                              <Row className="mt-2">
                                <Col>
                                  <div className="text-muted">
                                    <small className="">
                                      <strong>
                                        {row_items.diagnostics.title}
                                      </strong>
                                    </small>
                                  </div>
                                  {row_items.diagnostics.content}
                                </Col>
                                {!/ethernet/i.test(this._selectedEssid) ? (
                                  <Col>
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>{row_items.rssi.title}</strong>
                                      </small>
                                    </div>
                                    {row_items.rssi.content}
                                  </Col>
                                ) : null}
                              </Row>
                              <div className="mt-2">
                                <div className="text-muted">
                                  <small className="">
                                    <strong>{row_items.probe.title}</strong>
                                  </small>
                                </div>
                                {row_items.probe.content}
                              </div>
                            </div>
                          );
                        }}
                        thDividers
                        //	onTableLeave={() => {
                        //		this._pie_chart.unsetActive()
                        //	}}
                        //	onRowOver={(row_data) => {
                        //		console.log(row_data);
                        //		this._pie_chart.setActive(_avg_data[row_data.index], row_data.index)
                        //	}}
                        defaultSort={[
                          {
                            data_key: "probe",
                            order: "asc",
                          },
                          {
                            data_key: "diagnostics",
                            order: "asc",
                          },
                          {
                            constrain: "down",
                            data_key: "rssi",
                            func: (value) => {
                              return value == 0;
                            },
                          },
                        ]}
                        cols={[
                          {
                            title: "MEASURE",
                            align: "center",
                            data_key: "name",
                            width: "25",
                            sortable: true,
                          },
                          ...(!/ethernet/i.test(this._selectedEssid)
                            ? [
                                {
                                  title: "BSSID",
                                  align: "center",
                                  data_key: "bssid",
                                  width: "15",
                                  sortable: true,
                                },
                              ]
                            : []),
                          {
                            title: "DIAGNOSTICS",
                            align: "center",
                            data_key: "diagnostics",
                            width: "20",
                            sortable: true,
                          },
                          ...(!/ethernet/i.test(this._selectedEssid)
                            ? [
                                {
                                  title: (
                                    <span>
                                      <span className="icon-wifi mr-2" />
                                      RSSI (dBm)
                                    </span>
                                  ),
                                  align: "center",
                                  data_key: "rssi",
                                  width: "15",
                                  sortable: true,
                                },
                              ]
                            : []),
                          //	{
                          //		title: (<span id="_tooltip_OI_"><ReactOTooltip placement="bottom" target="_tooltip_OI_" text="Overlap index"/>OVERLAP</span>),
                          //		align: 'center',
                          //		data_key: 'overlap',
                          //		width: '10',
                          //		sortable: true
                          //	},
                          {
                            title: "PROBE",
                            align: "center",
                            data_key: "probe",
                            width: "20",
                            sortable: true,
                          },
                        ]}
                        rows={(() => {
                          let _TMP = [];
                          //	let _probesColors = {};
                          let _isEthernet = /ethernet/i.test(
                            this._selectedEssid,
                          );
                          this.state.data[this._selectedEssid].measures
                            .filter((_C_entry) => {
                              return _C_entry.test == this._selectedTest;
                            })
                            .forEach((_C_measure, _C_idx2) => {
                              //		if (!_probesColors[_C_measure.probe_data.name]) {
                              //			_probesColors[_C_measure.probe_data.name] = this.getAppContext().colors['gray' + (100 + (Object.keys(_probesColors).length * 100))];
                              //		}
                              _C_measure.dataPerBssid.forEach(
                                (_C_bssid, _C_idx3) => {
                                  _TMP.push({
                                    _link:
                                      "/" +
                                      _C_measure.prb_id +
                                      "/active/" +
                                      _C_measure.cssid +
                                      "/" +
                                      (_isEthernet
                                        ? "overal"
                                        : _C_bssid.bssid.replace(/:/g, "")),
                                    //				_color: _probesColors[_C_measure.probe_data.name],
                                    name: {
                                      value: _C_measure.name,
                                      render:
                                        this.getAppContext().media.isMobile ||
                                        this.getAppContext().media.isTablet ? (
                                          <h5>{_C_measure.name}</h5>
                                        ) : (
                                          <h6>{_C_measure.name}</h6>
                                        ),
                                    },
                                    bssid: {
                                      value: _C_bssid.bssid,
                                      render: (
                                        <div
                                          className={
                                            !this.getAppContext().media
                                              .isMobile &&
                                            !this.getAppContext().media.isTablet
                                              ? "text-center"
                                              : ""
                                          }
                                        >
                                          <Row>
                                            <Col xs={12}>
                                              <h5>{_C_bssid.bssid}</h5>
                                            </Col>
                                          </Row>
                                          {_C_bssid.bssid_info ? (
                                            <Row>
                                              <Col xs={12}>
                                                {_C_bssid.bssid_info
                                                  .ap_custom_data ? (
                                                  (() => {
                                                    let _tooltip_id = _C_bssid
                                                      .bssid_info.ap_custom_data
                                                      .mac_lan
                                                      ? "_ap_cst_" +
                                                        _C_bssid.bssid.replace(
                                                          /:/g,
                                                          "",
                                                        ) +
                                                        "_" +
                                                        _C_bssid.bssid_info.ap_custom_data.mac_lan.replace(
                                                          /:/g,
                                                          "",
                                                        )
                                                      : null;
                                                    return (
                                                      <span
                                                        className="sub-title"
                                                        id={_tooltip_id}
                                                      >
                                                        {_C_bssid.bssid_info
                                                          .ap_custom_data
                                                          .mac_lan ? (
                                                          <ReactOTooltip
                                                            placement="bottom"
                                                            target={_tooltip_id}
                                                            text={
                                                              "LAN mac address: " +
                                                              _C_bssid
                                                                .bssid_info
                                                                .ap_custom_data
                                                                .mac_lan
                                                            }
                                                          />
                                                        ) : null}
                                                        {_C_bssid.bssid_info
                                                          .ap_custom_data.name +
                                                          (_C_bssid.bssid_info
                                                            .ap_custom_data
                                                            .ip == ""
                                                            ? ""
                                                            : " - " +
                                                              _C_bssid
                                                                .bssid_info
                                                                .ap_custom_data
                                                                .ip)}
                                                      </span>
                                                    );
                                                  })()
                                                ) : (
                                                  <span>
                                                    {
                                                      _C_bssid.bssid_info
                                                        .long_desc
                                                    }
                                                  </span>
                                                )}
                                              </Col>
                                            </Row>
                                          ) : null}
                                        </div>
                                      ),
                                    },
                                    diagnostics: {
                                      value: _C_bssid.diagnostics.last_state
                                        ? this.getAppContext().conf
                                            .MLY_STATES_DICTIONARY[
                                            _C_bssid.diagnostics.last_state
                                          ].value
                                        : this.getAppContext().conf
                                            .MLY_STATES_DICTIONARY["NA"].value,
                                      render: (
                                        <div>
                                          {_C_bssid.diagnostics.last_state ? (
                                            <span
                                              className={
                                                "text-" +
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY[
                                                  _C_bssid.diagnostics
                                                    .last_state
                                                ].color
                                              }
                                            >
                                              {
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY[
                                                  _C_bssid.diagnostics
                                                    .last_state
                                                ].text
                                              }
                                            </span>
                                          ) : (
                                            <div
                                              className={
                                                "text-" +
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY["NA"]
                                                  .color
                                              }
                                            >
                                              {
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY["NA"]
                                                  .text
                                              }
                                            </div>
                                          )}
                                        </div>
                                      ),
                                    },
                                    rssi: {
                                      value: _C_bssid.rssi,
                                      render: (
                                        <span
                                          className={classnames({
                                            "text-success":
                                              _C_bssid.rssi >= -60,
                                            "text-orange":
                                              _C_bssid.rssi >= -74 &&
                                              _C_bssid.rssi < -60,
                                            "text-danger": _C_bssid.rssi < -74,
                                          })}
                                        >
                                          {_C_bssid.rssi}
                                        </span>
                                      ),
                                    },
                                    overlap: _C_bssid.overlap,
                                    probe: {
                                      value: this.state.data[
                                        this._selectedEssid
                                      ].probes.find((_C_probe) => {
                                        return (
                                          _C_measure.prb_id == _C_probe.prb_id
                                        );
                                      }).name,
                                      render: (
                                        <span>
                                          {
                                            this.state.data[
                                              this._selectedEssid
                                            ].probes.find((_C_probe) => {
                                              return (
                                                _C_measure.prb_id ==
                                                _C_probe.prb_id
                                              );
                                            }).name
                                          }
                                        </span>
                                      ),
                                    },
                                  });
                                },
                              );
                            });
                          return _TMP;
                        })()}
                      />
                    </div>
                  </Col>
                ) : null}
              </Row>
            ) : null}
          </Panel>
        </_LoadingWrapper>
      </Section>
    );
  }
}

export default contextProvider(
  //	Sites,
  withDefinedContext(Dashboard, "Dashboard", context_exposed_methods),
  {
    retrieve: ["_LayoutSidebar"],
  },
);
